import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    bold: {
      fontWeight: 'bold',
    },
    emptyReportMessageContainer: {
      marginTop: 140,
    },
    margin: {
      marginTop: 63,
    },
  }),
);
